module.exports = __webpack_public_path__ + "img/nb_invoice.2e416fe9.svg";